import { State, Selector, Action, StateContext } from "@ngxs/store";
import {
  AddVacColumnDefinition,
  RemoveVacColumnDefinition,
} from "../actions/vacColumnDefinition.action";
import { DataColumn } from "../../models/ColumnDefintion";

export class VacColumnDefinitionStateModel {
    VacColDef: DataColumn[];
}

@State({
  name: "VacColDef",
  defaults: {
    VacColDef: undefined,
  },
})
export class VacColumnDefinitionState {
  @Selector()
  getVacColumnDefinition(state: VacColumnDefinitionStateModel) {
    return state.VacColDef;
  }

  @Action(AddVacColumnDefinition)
  add(
    { patchState }: StateContext<VacColumnDefinitionStateModel>,
    { payload }: AddVacColumnDefinition
  ) {
    patchState({ VacColDef: payload });
  }

  @Action(RemoveVacColumnDefinition)
  remove({ patchState }: StateContext<VacColumnDefinitionStateModel>): void {
    patchState({ VacColDef: undefined });
  }
}
